a.location = (function(){
	return {}
}());